import { TagColors } from "../../components/atoms/Tag"
import React, { createContext, useMemo } from "react"

export interface TableRowProviderModel {
    color?: TagColors
}

export const TableRowContext = createContext<TableRowProviderModel>({
    color: undefined,
})

export const TableRowProvider = ({ children, color }: { children: React.ReactNode, color?: TagColors }) => {
    const providerValue = useMemo(() => ({ color }), [color])
    
    return <TableRowContext.Provider value={providerValue}>{children}</TableRowContext.Provider>
}